import { useEffect } from "react";
import { Link } from "react-router-dom";
import ARTICLES from "@/blogData";
import { useSiteSettings } from "@/siteSettings";

export function BlogHeader() {
  const settings = useSiteSettings();
  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-slate-200/80">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center space-x-3" data-testid="blog-header-home">
          <img src="/logo-mark.png" alt="Nurrahma Logistics" className="h-10 w-auto" />
          <div>
            <span className="text-lg font-black tracking-tight text-blue-950 block leading-tight">NURRAHMA LOGISTICS</span>
            <span className="text-[11px] font-semibold text-slate-500 uppercase tracking-widest">{settings.tagline}</span>
          </div>
        </Link>
        <Link to="/#kontak" className="inline-flex items-center justify-center px-4 py-2.5 rounded-lg bg-blue-900 text-amber-300 font-semibold text-sm hover:bg-blue-950 transition-colors shadow-sm" data-testid="blog-cta-penawaran">
          Minta Penawaran
        </Link>
      </div>
    </header>
  );
}

export default function BlogList() {
  useEffect(() => {
    document.title = "Blog Tips Kirim Barang | Nurrahma Logistics";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", "Panduan dan tips pengiriman barang: hitung volumetrik, pilih moda darat/laut/udara, packing aman, dan panduan kirim ke Papua dari Nurrahma Logistics Makassar.");
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="font-sans antialiased bg-[#F4F7FB] text-slate-800 min-h-screen">
      <BlogHeader />
      <section className="bg-blue-950 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-xs font-bold uppercase tracking-widest text-amber-400">Blog Tips Logistik</span>
          <h1 className="text-3xl sm:text-4xl font-black tracking-tight mt-2" data-testid="blog-list-title">Panduan Kirim Barang untuk UMKM & Perusahaan</h1>
          <p className="mt-4 text-slate-300 text-sm sm:text-base max-w-2xl">Kumpulan panduan praktis seputar ongkir, moda pengiriman, dan packing dari tim operasional kami di Makassar.</p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6">
          {ARTICLES.map((a) => (
            <Link key={a.slug} to={`/blog/${a.slug}`} className="block p-6 rounded-2xl bg-white border border-slate-200 hover:border-blue-300 hover:shadow-md transition-all" data-testid={`blog-card-${a.slug}`}>
              <span className="text-[10px] font-bold text-amber-700 uppercase tracking-widest">{a.category}</span>
              <h2 className="text-lg font-extrabold text-slate-900 mt-1.5">{a.title}</h2>
              <p className="text-sm text-slate-600 mt-2 leading-relaxed">{a.excerpt}</p>
              <span className="text-xs font-bold text-blue-900 mt-3 inline-block">Baca Panduan →</span>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
